export default "__VITE_PUBLIC_ASSET__80e5837b__"